<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <div class="settings-header" navTabs>
        <sbnb-page-header>
          <div>
            <h2 fxFlex fxLayout fxLayoutAlign="space-apart center">Properties</h2>
            <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
          </div>
        </sbnb-page-header>
      </div>
      <div fxLayout class="settings-header">
        <h2 fxFlex fxLayout fxLayoutAlign="space-apart center">Properties</h2>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>
    </app-feature-flag-tabs>

    <ng-container *ngIf="propertiesData">
      <div
        class="setting_section"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="12px"
        fxLayout.lt-lg="column"
        fxLayoutAlign.lt-lg="start start">
        <div fxFlex>
          <h3>Property names</h3>

          <span>{{ propertiesData.meta.descriptions.reset_names.description }}</span>
        </div>

        <sbnb-button
          size="mini"
          [disabled]="resetting"
          (clicked)="resetPropertyNamesClicked()"
          [label]="propertiesData.meta.descriptions.reset_names.title"></sbnb-button>

        <mat-spinner *ngIf="resetting" [diameter]="16"></mat-spinner>
      </div>

      <!-- Lead platform -->
      <div
        class="setting_section"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="12px"
        fxLayout.lt-lg="column"
        fxLayoutAlign.lt-lg="start start">
        <div fxFlex>
          <h3 class="flex items-center gap-2">
            Lead platform
            <sbnb-badge context="positive">new</sbnb-badge>
          </h3>

          <span>
            For properties with listings on multiple platforms, this determines which platform we use as the lead to
            pull property data & fee information.
          </span>
          <span fxLayout fxLayoutAlign="start center" fxLayoutGap="6px" style="margin-top: 16px">
            <sbnb-icon icon="details" class="text-smoke-darker"></sbnb-icon>
            <span>
              You can override this default lead platform on a per property basis on the property details page.
            </span>
          </span>

          <div
            fxLayout
            fxLayoutGap="12px"
            fxLayoutAlign="start center"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start start"
            class="lead-platform-radio-group">
            <mat-radio-group
              fxFlex
              aria-label="Select a lead platform"
              [value]="propertiesData.lead_platform"
              (change)="selectedLeadPlatform = $event.value">
              <mat-radio-button value="airbnb">
                <span fxLayoutAlign="start center" fxLayoutGap="12px">
                  <sbnb-icon-airbnb></sbnb-icon-airbnb>
                  <span>Airbnb</span>
                </span>
              </mat-radio-button>

              <mat-radio-button value="homeaway">
                <span fxLayoutAlign="start center" fxLayoutGap="12px">
                  <sbnb-icon-homeaway></sbnb-icon-homeaway>
                  <span>Vrbo</span>
                </span>
              </mat-radio-button>
              <mat-radio-button value="booking">
                <span fxLayoutAlign="start center" fxLayoutGap="12px">
                  <sbnb-icon-booking></sbnb-icon-booking>
                  <span>Booking.com</span>
                </span>
              </mat-radio-button>
            </mat-radio-group>

            <sbnb-button
              size="mini"
              [label]="savingLeadPlatform ? 'Saving...' : 'Save lead platform'"
              [loading]="savingLeadPlatform"
              (click)="saveLeadPlatform(selectedLeadPlatform)"></sbnb-button>
          </div>
        </div>
      </div>

      <div *ngIf="markupsData" class="setting_section setting_section-noborder">
        <h3>Pricing markup rates</h3>

        <span>
          Define your markup rates for each platform. We will use this markup to calculate the final rate that we send
          to each platform through our Calendar, and through pricing integrations.
        </span>

        <div fxLayout style="margin-top: 16px" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
          <span fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="6px">
            <sbnb-icon icon="details" class="text-smoke-darker"></sbnb-icon>
            <span>
              You can override these default platform markup rates on a
              <strong>per listing basis</strong>
              on the
              <strong>property details page.</strong>
            </span>
          </span>
        </div>

        <div fxLayout="column">
          <!-- First row: Airbnb and Vrbo (always shown) -->
          <div fxLayout fxLayoutGap="24px" fxLayout.lt-md="column" fxLayoutGap.lt-md="0px">
            <div fxFlex fxLayout fxLayoutAlign="start center" class="markup-container">
              <div fxFlex fxLayout="column" fxLayoutGap="10px">
                <div fxLayout fxLayoutGap="10px">
                  <sbnb-icon-airbnb></sbnb-icon-airbnb>
                  <span class="strong">Airbnb</span>
                </div>
                <span class="text__small night">Your Airbnb markup rate</span>
              </div>

              <mat-form-field class="markup-field">
                <input
                  #airbnbInput
                  matInput
                  type="tel"
                  maxlength="6"
                  [value]="airbnbMarkup === null ? null : (airbnbMarkup * 100 | number: '1.0-3')" />
                <span matSuffix>%</span>
              </mat-form-field>
            </div>

            <div fxFlex fxLayout fxLayoutAlign="start center" class="markup-container">
              <div fxFlex fxLayout="column" fxLayoutGap="10px">
                <div fxLayout fxLayoutGap="10px">
                  <sbnb-icon-homeaway></sbnb-icon-homeaway>
                  <span class="strong">Vrbo</span>
                </div>
                <span class="text__small night">Your Vrbo markup rate</span>
              </div>

              <mat-form-field class="markup-field">
                <input
                  #homeawayInput
                  matInput
                  type="tel"
                  maxlength="6"
                  [value]="vrboMarkup === null ? null : (vrboMarkup * 100 | number: '1.0-3')" />
                <span matSuffix>%</span>
              </mat-form-field>
            </div>
          </div>

          <!-- Second row: Booking.com and either Agoda or Direct -->
          <div fxLayout fxLayoutGap="24px" fxLayout.lt-md="column" fxLayoutGap.lt-md="0px">
            <!-- Booking.com (always shown) -->
            <div fxFlex fxLayout fxLayoutAlign="start center" class="markup-container">
              <div fxFlex fxLayout="column" fxLayoutGap="10px">
                <div fxLayout fxLayoutGap="10px">
                  <sbnb-icon-booking></sbnb-icon-booking>
                  <span class="strong">Booking.com</span>
                </div>
                <span class="text__small night">Your Booking.com markup rate</span>
              </div>

              <mat-form-field class="markup-field">
                <input
                  #bookingInput
                  matInput
                  type="tel"
                  maxlength="6"
                  [value]="bookingMarkup === null ? null : (bookingMarkup * 100 | number: '1.0-3')" />
                <span matSuffix>%</span>
              </mat-form-field>
            </div>

            <!-- Agoda (always shown) -->
            <div fxFlex fxLayout fxLayoutAlign="start center" class="markup-container">
              <div fxFlex fxLayout="column" fxLayoutGap="10px">
                <div fxLayout fxLayoutGap="10px">
                  <sbnb-icon-agoda></sbnb-icon-agoda>
                  <span class="strong">Agoda</span>
                </div>
                <span class="text__small night">Your Agoda markup rate</span>
              </div>

              <mat-form-field class="markup-field">
                <input
                  #agodaInput
                  matInput
                  type="tel"
                  maxlength="6"
                  [value]="agodaMarkup === null ? null : (agodaMarkup * 100 | number: '1.0-3')" />
                <span matSuffix>%</span>
              </mat-form-field>
            </div>
          </div>

          <!-- Third row: Direct (shown only if enabled) -->
          <div
            *ngIf="directEnabled$ | async"
            fxLayout
            fxLayoutGap="24px"
            fxLayout.lt-md="column"
            fxLayoutGap.lt-md="0px">
            <div fxFlex fxLayout fxLayoutAlign="start center" class="markup-container">
              <!-- Direct markup input -->
              <div fxFlex fxLayout="column" fxLayoutGap="10px">
                <div fxLayout fxLayoutGap="10px">
                  <sbnb-icon-smartbnb></sbnb-icon-smartbnb>
                  <span class="strong">Direct</span>
                </div>
                <span class="text__small night">Your Direct markup rate</span>
              </div>

              <mat-form-field class="markup-field">
                <input
                  #directInput
                  matInput
                  type="tel"
                  maxlength="6"
                  [value]="directMarkup === null ? null : (directMarkup * 100 | number: '1.0-3')" />
                <span matSuffix>%</span>
              </mat-form-field>
            </div>
            <div fxFlex class="markup-container markup-container-blank">
              <!-- intentionally blank for layout -->
            </div>
          </div>
        </div>

        <div fxLayoutAlign="end center" fxLayoutAlign.lt-md="start center" style="margin-top: 24px">
          <sbnb-button
            size="mini"
            [disabled]="savingMarkups"
            (clicked)="saveMarkups()"
            label="Save markups"></sbnb-button>
        </div>
      </div>
    </ng-container>

    <div fxLayout fxLayoutAlign="end" style="margin-top: 24px">
      <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
